<template lang="pug">
    div(class= "inset-32 content")
            p(class="fs7 insety-8") {{ $t('fut_mar_req_para_1') }}
            p(class="fs7 insety-8") {{ $t('fut_mar_req_para_2') }}
            p(class="fs7 insety-8 content-oblique") {{ $t('all_in_millions') }}
            ib-table-basic.ib-row.shrink.fs7.fg70.event-border(
            :data="netCapitalList",
            spacing="huge",
            height= "400px",
            ref="table",
            wrap,
            rowstripe,
            rowborder,
            colborder,
            )
                ib-table-col.event-header-border(width="10ch") {{ $t('month_end') }}
                ib-table-col.event-header-border(width="10ch") {{ $t('aff_prop_mar_req') }}
                ib-table-col.event-header-border(width="10ch") {{ $t('tot_cust_mar_req') }}
                ib-table-col.event-header-border(width="20ch") {{ $t('precentage_aff_total_cust') }}
                template(slot="body" slot-scope="row")
                    td(class="")
                        span(class="") {{ (row.month_year) }}
                    td(class="")
                        span(class="") {{ (row.prop_margin_requirement) }} 
                    td(class="")
                        span(class="") {{ (row.cust_margin_requirement) }}
                    td(class="")
                        span(class="") {{ (row.percent_prop_vs_cust_margin) }}

</template>

<script>
    import api from '../api/'

    export default {
        name: 'FuturesMarginRequirements',

        props:{
            netCapitalList: Array,
        },

        data() {
            return {
                
           }
        },

        methods: {
            
        },

        mounted() {
            
        },

        updated(){
            
        },

        watch: {

        }
    }
</script>

<style lang="less">
.event-border{
    ._tb{
        border-style:solid;
        border-width:1px;
        border-color:rgba(0, 0, 0, 0.1);
    }
}

.event-header-border{
    border-right-style:solid;
    border-right-width:1px;
    border-right-color:rgba(0, 0, 0, 0.1);
    border-top-style:solid;
    border-top-width:1px;
    border-top-color:rgba(0, 0, 0, 0.1);
}

.content{
    border-style: solid;
    border-width: 1px;
    border-color: #6666664f;
}
</style>
